import { render } from "./NumberList.vue?vue&type=template&id=0c84451a&scoped=true"
import script from "./NumberList.vue?vue&type=script&lang=js"
export * from "./NumberList.vue?vue&type=script&lang=js"

import "./NumberList.vue?vue&type=style&index=0&id=0c84451a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c84451a"]])

export default __exports__